module.exports = __webpack_public_path__ + "static/img/apollo_logo.73abcc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/apollo_logo.png
// module id = 6wPP
// module chunks = 2